
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function PlicaPolonica(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Plica polonica(Polish plait)"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Plica polonica is an <b>uncommon condition characterized by
                                        diffuse matting of hair</b>. It can be caused by various conditions
                                    such as psychiatric illnesses, pediculosis, pyoderma scalp and
                                    shampoos. It was prevalent in Poland in the 19th century, hence
                                    the name plica polonica or polish plait.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Plica-polonica/1.png")} alt="Plica-polonica" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p>Irregular twists and tangles in scalp hair</p>
                                <p>Formation of hard keratin mass that is impenetrable</p>
                                <p>Foul smell from hair mass</p>
                                <p>Hair cemented together with formation of pus, blood, crusts and dirt</p>
                                <p><a className='links' href='http://richfeel.com/hair-fall-cause/'>Hair loss</a> from rest of the scalp</p>
                                <p>Infestation with nits and lice</p>
                                <p>Inflammation of scalp</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Polish_plait">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default PlicaPolonica;